(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1493],{

/***/ 16840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/travel/vas/visa-application/[visaCountry]",
      function () {
        return __webpack_require__(3633);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19659);
/* harmony import */ var src_common_utils_globals_initialiseAckoAnalytics__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4789);
/* harmony import */ var src_common_custom_hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49452);
/* harmony import */ var src_vas_components_application_mobile__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93703);
/* harmony import */ var src_vas_components_application_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72949);
/* harmony import */ var src_common_utils_responsive__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7010);
/* harmony import */ var src_common_styles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31065);
/* harmony import */ var src_common_utils_segment__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(22701);











var Index = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var query = router === null || router === void 0 ? void 0 : router.query;
    var isMobile = (0,src_common_utils_responsive__WEBPACK_IMPORTED_MODULE_8__/* .useViewport */ .S)().isMobile;
    var setItem = (0,src_common_custom_hooks__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)().setItem;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        (0,src_common_utils_globals_initialiseAckoAnalytics__WEBPACK_IMPORTED_MODULE_4__/* .initialiseAckoAnalytics */ .x)();
        setItem(src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_3__/* .VAS.VAS_ROUTER_QUERY */ .xM.VAS_ROUTER_QUERY, JSON.stringify(query), "session");
        setItem(src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_3__/* .VAS.VAS_RESUME_BOOKING_REFERER */ .xM.VAS_RESUME_BOOKING_REFERER, "", "session");
        setItem(src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_3__/* .VAS.VAS_MY_BOOKING_REFERER */ .xM.VAS_MY_BOOKING_REFERER, "", "session");
        setItem(src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_3__/* .VAS.VAS_HISTORY_REFERER */ .xM.VAS_HISTORY_REFERER, "", "session");
        (0,src_common_utils_segment__WEBPACK_IMPORTED_MODULE_10__/* .sendVasEvents */ .J6)(src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_3__/* .VasViewEvents.VIEW_PAGE_VISA_ASSISTANCE_COUNTRY_SELECTION_PAGE */ .lO.VIEW_PAGE_VISA_ASSISTANCE_COUNTRY_SELECTION_PAGE);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
        children: isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(src_common_styles__WEBPACK_IMPORTED_MODULE_9__/* .FlexContainer */ .Ej, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(src_vas_components_application_mobile__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(src_vas_components_application_desktop__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Index);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [381,6073,5158,5675,5673,8884,292,8905,2888,179], function() { return __webpack_exec__(16840); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);